export default __webpack_public_path__ + "static/media/marseille-hightlited-1x.9708a3b5.webp";